import * as React from 'react';

import iconUrl from './index.svg';

export const IconComments = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img width="79" height="51" {...props} src={iconUrl} alt="" />
);
